import type { IEntityData } from "../../defines";


export function make_fighter_data_dennis(data: IEntityData) {
  data.base.bg_face ??= "sprite/MENU_BACK4.png";
  return data;
}

